
import { supabase } from '@/integrations/supabase/client';
import { ProcurementWarehouse, CreateProcurementWarehouseInput } from '@/types/database.types';

export const createProcurementWarehouse = async (data: CreateProcurementWarehouseInput): Promise<ProcurementWarehouse> => {
  const { data: result, error } = await supabase
    .from('procurement_warehouse')
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error('Error creating procurement warehouse:', error);
    throw error;
  }

  return result as ProcurementWarehouse;
};

export const getProcurementWarehouse = async (procurementId: string): Promise<ProcurementWarehouse | null> => {
  const { data, error } = await supabase
    .from('procurement_warehouse')
    .select('*')
    .eq('procurement_id', procurementId)
    .maybeSingle();

  if (error) {
    console.error('Error fetching procurement warehouse:', error);
    throw error;
  }

  return data as ProcurementWarehouse | null;
};

export const updateProcurementWarehouse = async (
  procurementId: string, 
  updates: Partial<CreateProcurementWarehouseInput>
): Promise<ProcurementWarehouse> => {
  const { data, error } = await supabase
    .from('procurement_warehouse')
    .update(updates)
    .eq('procurement_id', procurementId)
    .select()
    .single();

  if (error) {
    console.error('Error updating procurement warehouse:', error);
    throw error;
  }

  return data as ProcurementWarehouse;
};

export const rejectProcurementWarehouse = async (
  procurementId: string,
  rejectedBy: string,
  rejectionReason: string,
  sampleTaken: boolean = false,
  damagePercentage: number = 0,
  netKgPayable?: number,
  inspectionNotes?: string
): Promise<ProcurementWarehouse> => {
  const updates: Partial<CreateProcurementWarehouseInput> = {
    warehouse_rejected_by: rejectedBy,
    warehouse_rejection_date: new Date().toISOString(),
    warehouse_rejection_reason: rejectionReason,
    sample_taken: sampleTaken,
    damage_percentage: damagePercentage,
    net_kg_payable: netKgPayable,
    inspection_notes: inspectionNotes
  };

  return updateProcurementWarehouse(procurementId, updates);
};

export const confirmProcurementWarehouse = async (
  procurementId: string,
  confirmedBy: string,
  netKgPayable?: number,
  inspectionNotes?: string
): Promise<ProcurementWarehouse> => {
  const updates: Partial<CreateProcurementWarehouseInput> = {
    warehouse_confirmed_by: confirmedBy,
    warehouse_confirmation_date: new Date().toISOString(),
    net_kg_payable: netKgPayable,
    inspection_notes: inspectionNotes
  };

  return updateProcurementWarehouse(procurementId, updates);
};
